<template>
  <div class="partner-modal">
    <div class="error-modal-body">
      <div class="row" style="width: 100%; margin: 0; padding: 0">
        <div class="title" style="width: 100%">
          <p>Хүүхдийн карт нэмэх</p>
          <button @click.esc="close">x</button>
        </div>
      </div>
      <b-alert
        v-if="showMessage"
        variant="warning"
        dismissible
        :show="true"
        class="warning"
        style="margin-left: auto; margin-right: auto; margin-top: 25px"
      >
        {{ errorMessage }}
      </b-alert>
      <form
        action="POST"
        class="user-edit-panel-profile"
        @submit.prevent="sendData"
      >
        <div class="form-group">
          <label for="">ОВОГ / Last Name : </label>
          <div class="user-input">
            <input
              type="text"
              class="form-control"
              v-model="lastname"
              required
              disabled
            />
          </div>
        </div>
        <div class="form-group">
          <label for="">НЭР / First Name : </label>
          <div class="user-input">
            <input
              type="text"
              class="form-control"
              v-model="firstname"
              required
              disabled
              help-text="Хүүхдийн нэрийг оруулна уу / Please enter child's name"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="">РЕГИСТЕР / ID number : </label>
          <div class="user-input">
            <input
              type="text"
              class="form-control col-md-6"
              v-model="registerNumber"
              required
              disabled
            />
          </div>
        </div>
        <div class="form-group">
          <label for="">Утасны дугаар (хүүхдийн) / Phone Number : </label>
          <div class="user-input">
            <input
              type="text"
              class="form-control"
              v-model="phonenumber"
              required
            />
          </div>
        </div>
        <div class="form-group">
          <label for="">Өдрийн хязгаар / Daily limit : </label>
          <div class="user-input">
            <input type="number" class="form-control" v-model="dailyLimit" />
          </div>
        </div>
        <div class="form-group">
          <label for="">и-мэйл хаяг / Email :<span>*</span> </label>
          <div class="user-input">
            <input type="text" class="form-control" v-model="email" required />
          </div>
        </div>
        <div class="form-group">
          <label for="">Тан Код / Tan Code :<span>*</span> </label>
          <div class="user-input">
            <input
              type="number"
              class="form-control"
              v-model="tanCode"
              required
              style="width: 150px"
            />
            <input
              type="button"
              @click="getTanCode"
              value="код авах"
              class="btn"
              style="width: 150px; margin-right: 5px"
            />
          </div>
        </div>
        <div class="form-group" style="justify-content: center">
          <input
            type="submit"
            class="btn user-btn"
            value="Хадгалах"
            :disabled="isDisabled"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import letterJSON from "@/json/data.vue";
export default {
  props: ["childInfo", "otherInfo"],
  data() {
    return {
      lastname: this.childInfo.lastName || "",
      firstname: this.childInfo.firstName || "",
      phonenumber: "",
      registerNumber: this.childInfo.regnum || "",
      email: "",
      isDisabled: false,
      letters: letterJSON.myJson,
      dailyLimit: 15000,
      tanCode: null,
      showMessage: false,
      errorMessage: "",
    };
  },
  methods: {
    close() {
      this.$emit("hideChildrenModal");
    },
    sendData() {
      var result = {
        firstName: this.firstname,
        lastName: this.lastname,
        walletId: this.otherInfo.accountId,
        mail: this.email,
        homeAddress: this.otherInfo.customerAddressHome,
        gender: "M",
        registryNumber: this.registerNumber,
        dailyLimit: this.dailyLimit,
        systemId: "BONUS",
        tanCode: this.tanCode,
        phoneNumber: this.phonenumber,
      };
      this.$cardApi
        .post("/kid-card/create", result, {
          headers: {
            "Accept-Language": "mn",
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            this.close();
            alert("Карт амжилттай үүслээ!");
            window.location.reload();
          } else {
            this.showMessage = true;
            this.errorMessage = "Алдаа гарлаа";
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message;
          this.showMessage = true;
        });
    },
    getTanCode() {
      if (this.phonenumber === "") {
        // alert("Утасны дугаар оруулна уу!");
        this.errorMessage = "Утасны дугаар оруулна уу!";
        this.showMessage = true;
        return;
      }

      this.$cardApi
        .post(
          "/kid-card/tan/code",
          {
            phoneNumber: this.phonenumber,
          },
          {
            headers: {
              "Accept-Language": "en-US",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.errorMessage = "Хүүхдийн утасны дугаарт код илгээлээ!";
            this.showMessage = true;
          }
        })
        .catch((error) => {
          if (error.response.data.statusCode === 400) {
            this.errorMessage = "Энэ дугаар дээр бүртгэл үүссэн байна!";
            this.showMessage = true;
          } else if (error.response.data.errorCode === "425") {
            this.errorMessage =
              "Хүүхдийн карт 7-16 насны хүүхдэд нээх боломжтой!";
            this.showMessage = true;
          } else {
            this.errorMessage = error.response.data.message;
            this.showMessage = true;
          }
        });
    },
  },
  created() {
    console.log(this.childInfo, this.otherInfo, "USER");
  },
};
</script>
<style scoped>
.partner-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  padding: 0;
  margin: 0;
}
.error-modal-body {
  position: absolute;
  top: 15%;
  width: 800px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  padding-bottom: 30px;
}
.title {
  float: left;
}
.title p {
  padding: 8px 0;
  margin: 0;
  color: #fff;
  background-color: #1660ab;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding-left: 22px;
}
.title button {
  top: 6px;
  right: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #fff;
}
.box-text {
  padding-left: 40px;
}
.box-text p {
  padding: 10px 0;
  margin: 0;
  border: none;
  color: #7e7e7e;
}
.box-text h2 {
  padding: 10px 0;
  font-size: 16px;
  margin: 0;
  color: #1660ab;
  font-weight: 500;
  border: none;
}
.error-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 2000;
}
.btn {
  background-color: #1660ab;
  color: #fff;
  padding: 3px 50px;
  margin-left: 16px;
  line-height: 0.9;
}
.btn.redColor {
  background-color: #ed3237;
}
.top20 {
  margin-top: 20px;
}
.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body div p {
  margin: 0;
}
.error-modal-body .error-img {
  margin-top: 37px !important;
  height: 49px;
  flex: 0.5;
  padding-left: 18px;
  line-height: 1.38;
}
.error-modal-body .error-close {
  width: auto;
  margin-top: 21px !important;
  height: 49px;
  padding-right: 18px;
  color: #fff;
}
.error-modal-body img {
  width: 100%;
  cursor: pointer;
}
.error-modal-body .error-message-icon {
  margin-top: 37px;
  height: 49px;
  flex: 0.8;
  font-size: 38px;
  color: #fff;
  padding-left: 24px;
  display: flex;
  justify-content: flex-end;
}
.error-modal-body .error-message-btn {
  margin-top: 25px;
  height: 49px;
  flex: 0.8;
  font-size: 18px;
  color: #fff;
  padding-right: 18px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
}
.exitBtn {
  top: 0;
  right: 0;
  color: #fff;
  width: 32px;
  height: 32px;
  position: absolute;
}
@media screen and (max-width: 500px) {
  .error-modal-body {
    margin-top: 20%;
  }
}
@media screen and (max-width: 800px) {
  .error-modal-body {
    margin-top: 20%;
    width: 80%;
  }
  .box-text {
    padding-left: 30px;
  }
}
.bonus-transfer {
  margin: 0;
  padding: 10px 14px;
  border: 1px dashed #bdbdbd;
  margin-top: 14px;
}
.bonus-transfer p {
  margin: 0;
  font-size: 12px;
}
.colorRed {
  color: #ed3237;
}
.bonus-transfer b {
  color: #1660ab;
}
@media screen and (max-width: 767px) {
  .error-modal-body {
    width: 90%;
    top: 0;
  }
  .col-md-4 {
    max-width: 33.333333%;
  }
  .col-md-8 {
    max-width: 66.666667%;
    padding-left: 10px;
  }
  .box-text h2 {
    font-size: 12px;
  }
  .box-text p {
    font-size: 12px;
  }
  .btn {
    padding: 5px 10px;
    font-size: 14px;
  }
}
</style>
